import React, { useState } from 'react';
import { IconButton, InputAdornment, styled, TextField, Tooltip, Typography } from '@mui/material';
import { Done } from '@mui/icons-material';
import Dialog from 'components/dialogs/Dialog';
import MoneyInput from 'components/masked-input/MoneyInput';
import { moneyFormat } from 'helpers/moneyFormat';
import { asInputComponent } from 'components/masked-input/asInputComponent';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
  padding: 10,
});

interface EditChargedValueDialogProps {
  title: string;
  value: number;
  min?: number;
  max?: number;
  onSave(value: number): void;
  onExited(): void;
}

// Abaixo do mínimo é permitido, mas avisa: quem tem permissão para editar decide.
const EditChargedValueDialog: React.FC<EditChargedValueDialogProps> = ({
  title,
  value,
  min,
  max,
  onSave,
  onExited,
}) => {
  const [newValue, setNewValue] = useState(value || 0);
  const belowMin = min !== undefined && newValue < min;

  return (
    <Dialog
      onExited={onExited}
      title={title}
      maxWidth="sm"
      ComponentActions={
        <Tooltip title="Salvar">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              onSave(newValue);
              onExited();
            }}
          >
            <Done />
          </IconButton>
        </Tooltip>
      }
    >
      <Container>
        {min !== undefined && (
          <Typography variant="body2">
            Valor mínimo: <b>{moneyFormat(min)}</b>
          </Typography>
        )}
        {max !== undefined && (
          <Typography variant="body2">
            Valor máximo sugerido: <b>{moneyFormat(max)}</b>
          </Typography>
        )}

        <TextField
          fullWidth
          autoFocus
          size="small"
          label="Valor que será cobrado"
          value={newValue}
          onChange={e => setNewValue(Number(e.target.value))}
          error={belowMin}
          helperText={belowMin ? 'Valor abaixo do mínimo' : ' '}
          sx={{ mt: 2 }}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              inputComponent: asInputComponent(MoneyInput),
            },
          }}
        />
      </Container>
    </Dialog>
  );
};

export default EditChargedValueDialog;
